module.exports = __webpack_public_path__ + "img/logo-new-version.a5e08521.png";